import { useState, useEffect } from 'react'
import Card from '../components/Card'

const units = {
  J: { name: 'Joule', factor: 1 },
  kJ: { name: 'Kilojoule', factor: 1000 },
  cal: { name: 'Calorie', factor: 4.184 },
  kcal: { name: 'Kilocalorie', factor: 4184 },
  'kWh': { name: 'Kilowatt Hour', factor: 3600000 },
  'BTU': { name: 'British Thermal Unit', factor: 1055.06 },
  'ft-lb': { name: 'Foot-Pound', factor: 1.35582 },
  'eV': { name: 'Electron Volt', factor: 1.60218e-19 },
}

export default function EnergyConverter() {
  const [fromUnit, setFromUnit] = useState('J')
  const [toUnit, setToUnit] = useState('cal')
  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  const convert = () => {
    if (!fromValue || isNaN(fromValue)) {
      setToValue('')
      return
    }

    const value = parseFloat(fromValue)
    const fromFactor = units[fromUnit].factor
    const toFactor = units[toUnit].factor

    const joules = value * fromFactor
    const result = joules / toFactor

    setToValue(result.toFixed(6).replace(/\.?0+$/, ''))
  }

  useEffect(() => {
    convert()
  }, [fromUnit, toUnit, fromValue])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">From:</label>
              <select
                value={fromUnit}
                onChange={(e) => setFromUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="number"
                value={fromValue}
                onChange={(e) => setFromValue(e.target.value)}
                className="input w-full mt-3"
                placeholder="Enter value"
                step="any"
              />
            </div>
            <div>
              <label className="label">To:</label>
              <select
                value={toUnit}
                onChange={(e) => setToUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="text"
                value={toValue}
                readOnly
                className="input w-full mt-3 bg-gray-50"
                placeholder="Result"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

